export default __webpack_public_path__ + "static/media/Home_thmb_Goto.11fbb00d.png";